// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* Shared enterprise scrollbar — import into dashboard SCSS roots. */
.business-dashboard {
  --bd-canvas: #f3f4f8;
  --bd-card: #ffffff;
  --bd-card2: #f7f8fb;
  --bd-line: #e3e5ee;
  --bd-text: #161a3a;
  --bd-muted: #646a8a;
  --bd-soft: #9aa0bb;
  --bd-workshop: #00c179;
  --bd-fleet: #3b82f6;
  --bd-sianty: #8b5cf6;
  --bd-warning: #f59e0b;
  --bd-danger: #ef4444;
  color: var(--bd-text);
  font-family: "Open Sans", "Roboto", Helvetica, Arial, sans-serif;
  font-size: 13.5px;
  line-height: 1.4;
  background: var(--bd-canvas);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin: -20px;
  padding: 12px 12px 24px;
  min-height: calc(100vh - 64px);
  width: auto;
}
.business-dashboard .bd-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 0;
  padding: 10px 14px;
  background: #fff;
  border: 1px solid #e3e5ee;
  border-radius: 10px;
  box-shadow: none;
}
.business-dashboard .bd-toolbar-left {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
  padding-right: 8px;
}
.business-dashboard .bd-badge {
  background: #00c179;
  color: #fff;
  font-weight: 700;
  letter-spacing: 0.04em;
  font-size: 12px;
  padding: 8px 12px;
  border-radius: 8px;
  white-space: nowrap;
}
.business-dashboard .bd-toolbar h1 {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: -0.01em;
  line-height: 1.25;
  color: #1b1f4b;
}
.business-dashboard .bd-toolbar p {
  margin: 2px 0 0;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.35;
  color: #646a8a;
}
.business-dashboard .bd-toolbar-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-left: auto;
}
.business-dashboard .bd-select,
.business-dashboard .bd-print-btn {
  border: 1px solid var(--bd-line);
  border-radius: 8px;
  padding: 8px 12px;
  font-size: 12px;
  background: #fff;
  color: var(--bd-text);
  outline: none;
  min-height: 36px;
}
.business-dashboard .bd-select:focus {
  border-color: #00c179;
}
.business-dashboard .bd-print-btn {
  background: #00c179;
  color: #fff;
  border-color: #00c179;
  font-weight: 600;
  cursor: pointer;
}
.business-dashboard .bd-print-btn:hover {
  background: #00b06e;
}
.business-dashboard .bd-section {
  margin-bottom: 12px;
}
.business-dashboard .bd-section-head {
  align-items: center;
  background: #fff;
  border: 1px solid #e3e5ee;
  border-radius: 10px;
  box-shadow: none;
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: space-between;
  margin-bottom: 12px;
  padding: 10px 14px;
}
.business-dashboard .bd-section-head-right {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-left: auto;
}
.business-dashboard .bd-switch {
  align-items: center;
  background: #fff;
  border: 1px solid var(--bd-line);
  border-radius: 8px;
  cursor: pointer;
  display: inline-flex;
  gap: 8px;
  min-height: 36px;
  padding: 6px 10px;
  -webkit-user-select: none;
          user-select: none;
}
.business-dashboard .bd-switch input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}
.business-dashboard .bd-switch-track {
  background: #d1d5e4;
  border-radius: 999px;
  display: inline-flex;
  flex-shrink: 0;
  height: 18px;
  position: relative;
  transition: background 0.15s ease;
  width: 32px;
}
.business-dashboard .bd-switch-thumb {
  background: #fff;
  border-radius: 50%;
  box-shadow: 0 1px 2px rgba(22, 26, 58, 0.2);
  height: 14px;
  left: 2px;
  position: absolute;
  top: 2px;
  transition: transform 0.15s ease;
  width: 14px;
}
.business-dashboard .bd-switch.is-on .bd-switch-track {
  background: var(--bd-workshop);
}
.business-dashboard .bd-switch.is-on .bd-switch-thumb {
  transform: translateX(14px);
}
.business-dashboard .bd-switch-text {
  color: var(--bd-text);
  font-size: 12px;
  font-weight: 600;
  line-height: 1.15;
}
.business-dashboard .bd-eyebrow {
  margin: 0;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.12em;
  font-weight: 700;
  color: var(--bd-muted);
}
.business-dashboard .bd-eyebrow.workshop {
  color: var(--bd-workshop);
}
.business-dashboard .bd-eyebrow.fleet {
  color: var(--bd-fleet);
}
.business-dashboard .bd-eyebrow.sianty {
  color: var(--bd-sianty);
}
.business-dashboard .bd-section-head h2,
.business-dashboard .bd-card h2 {
  margin: 2px 0 0;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: -0.01em;
  line-height: 1.25;
  color: #1b1f4b;
}
.business-dashboard .bd-section-head p,
.business-dashboard .bd-card .bd-sub {
  margin: 2px 0 0;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.35;
  color: #646a8a;
}
.business-dashboard .bd-aside {
  font-size: 12px;
  font-weight: 500;
  color: var(--bd-muted);
  white-space: nowrap;
  margin-left: auto;
}
.business-dashboard .bd-aside.workshop {
  color: var(--bd-workshop);
}
.business-dashboard .bd-aside.fleet {
  color: var(--bd-fleet);
}
.business-dashboard .bd-aside.sianty {
  color: var(--bd-sianty);
}
.business-dashboard .bd-grid {
  display: grid;
  grid-gap: 12px;
  gap: 12px;
}
.business-dashboard .bd-grid-4 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.business-dashboard .bd-grid-2 {
  grid-template-columns: 1fr;
}
.business-dashboard .bd-grid-3 {
  grid-template-columns: 1fr;
}
.business-dashboard .bd-grid-5 {
  grid-template-columns: 1fr;
}
.business-dashboard .bd-trend-grid {
  grid-template-columns: 1fr;
}
.business-dashboard .bd-card {
  background: var(--bd-card);
  border: 1px solid var(--bd-line);
  border-radius: 10px;
  padding: 12px 14px;
  box-shadow: none;
  position: relative;
  overflow: hidden;
}
.business-dashboard .bd-card.accent::after {
  content: "";
  position: absolute;
  right: -35px;
  bottom: -55px;
  width: 130px;
  height: 130px;
  border-radius: 9999px;
  background: currentColor;
  opacity: 0.05;
  pointer-events: none;
}
.business-dashboard .bd-card.workshop-border {
  border-left: 4px solid var(--bd-workshop);
  color: var(--bd-workshop);
}
.business-dashboard .bd-card.fleet-border {
  border-left: 4px solid var(--bd-fleet);
  color: var(--bd-fleet);
}
.business-dashboard .bd-card.sianty-border {
  border-left: 4px solid var(--bd-sianty);
  color: var(--bd-sianty);
}
.business-dashboard .bd-label {
  margin: 0;
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--bd-muted);
  font-weight: 600;
}
.business-dashboard .bd-label-row {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
}
.business-dashboard .bd-label-row .bd-label {
  min-width: 0;
}
.business-dashboard .bd-info {
  display: inline-flex;
  align-items: center;
  line-height: 0;
  flex: 0 0 auto;
  cursor: help;
  color: var(--bd-soft);
}
.business-dashboard .bd-info:hover {
  color: var(--bd-fleet);
}
.business-dashboard .bd-info-icon {
  font-size: 14px !important;
}
.business-dashboard .bd-value {
  margin: 8px 0 0;
  font-size: 24px;
  font-weight: 700;
  color: var(--bd-text);
  line-height: 1.2;
}
.business-dashboard .bd-value.workshop {
  color: var(--bd-workshop);
}
.business-dashboard .bd-value.fleet {
  color: var(--bd-fleet);
}
.business-dashboard .bd-value.sianty {
  color: var(--bd-sianty);
}
.business-dashboard .bd-value.warning {
  color: var(--bd-warning);
}
.business-dashboard .bd-meta {
  display: flex;
  gap: 12px;
  margin-top: 6px;
  font-size: 12px;
}
.business-dashboard .bd-up {
  color: var(--bd-workshop);
}
.business-dashboard .bd-down {
  color: var(--bd-danger);
}
.business-dashboard .bd-muted {
  color: var(--bd-muted);
}
.business-dashboard .bd-warning {
  color: var(--bd-warning);
}
.business-dashboard .bd-danger {
  color: var(--bd-danger);
}
.business-dashboard .bd-kpi {
  min-height: 146px;
}
.business-dashboard .bd-workshop-kpis,
.business-dashboard .bd-fleet-kpis {
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 12px;
  gap: 12px;
}
.business-dashboard .bd-span-2 {
  min-width: 0;
}
.business-dashboard .bd-nested-head {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.business-dashboard .bd-pill {
  display: flex;
  align-items: center;
  gap: 8px;
  background: var(--bd-card2);
  border: 1px solid var(--bd-line);
  border-radius: 8px;
  padding: 8px 12px;
  width: fit-content;
}
.business-dashboard .bd-pill > span {
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--bd-muted);
}
.business-dashboard .bd-pill b {
  font-size: 18px;
}
.business-dashboard .bd-nested-grid {
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 12px;
  gap: 12px;
  margin-top: 16px;
}
.business-dashboard .bd-nested {
  background: var(--bd-card2);
  border-radius: 8px;
  padding: 14px;
}
.business-dashboard .bd-nested-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.business-dashboard .bd-note {
  margin-top: 10px;
  font-size: 10px;
  color: var(--bd-soft);
}
.business-dashboard .bd-chip {
  font-size: 10px;
  color: var(--bd-fleet);
  border: 1px solid rgba(59, 130, 246, 0.3);
  background: rgba(59, 130, 246, 0.08);
  padding: 4px 8px;
  border-radius: 6px;
  white-space: nowrap;
}
.business-dashboard .bd-month-row {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 8px;
  gap: 8px;
  margin-top: 16px;
}
.business-dashboard .bd-month {
  background: var(--bd-card2);
  border-radius: 8px;
  padding: 8px;
  text-align: center;
}
.business-dashboard .bd-month p {
  margin: 0;
  font-size: 9px;
  text-transform: uppercase;
  color: var(--bd-soft);
}
.business-dashboard .bd-month b {
  display: block;
  margin-top: 4px;
}
.business-dashboard .bd-part {
  background: var(--bd-card2);
  border: 1px solid var(--bd-line);
  border-radius: 8px;
  padding: 12px;
  margin-top: 12px;
}
.business-dashboard .bd-part-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  font-size: 12px;
}
.business-dashboard .bd-part-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  grid-gap: 8px;
  gap: 8px;
  margin-top: 12px;
  text-align: center;
  font-size: 12px;
}
.business-dashboard .bd-part-grid p {
  margin: 0;
  font-size: 9px;
  color: var(--bd-soft);
}
.business-dashboard .bd-part-total {
  border-left: 1px solid var(--bd-line);
}
.business-dashboard .bd-insight {
  margin-top: 12px;
  padding: 12px;
  border-radius: 8px;
  background: rgba(0, 193, 121, 0.08);
  border: 1px solid rgba(0, 193, 121, 0.18);
  font-size: 11px;
  color: #334155;
}
.business-dashboard .bd-insight.fleet {
  background: rgba(59, 130, 246, 0.08);
  border-color: rgba(59, 130, 246, 0.18);
}
.business-dashboard .bd-insight b.fleet {
  color: var(--bd-fleet);
}
.business-dashboard .bd-insight b.workshop {
  color: var(--bd-workshop);
}
.business-dashboard .bd-progress {
  margin-top: 20px;
}
.business-dashboard .bd-progress-row {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  margin-bottom: 6px;
}
.business-dashboard .bd-bar {
  height: 10px;
  background: var(--bd-canvas);
  border-radius: 999px;
  overflow: hidden;
}
.business-dashboard .bd-bar.thin {
  height: 8px;
}
.business-dashboard .bd-bar > span {
  display: block;
  height: 100%;
  border-radius: 999px;
}
.business-dashboard .bd-bar.workshop > span {
  background: var(--bd-workshop);
}
.business-dashboard .bd-bar.fleet > span {
  background: var(--bd-fleet);
}
.business-dashboard .bd-bar.sianty > span {
  background: var(--bd-sianty);
}
.business-dashboard .bd-bar.warning > span {
  background: var(--bd-warning);
}
.business-dashboard .bd-bar.slate > span {
  background: #94a3b8;
}
.business-dashboard .bd-stat-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.business-dashboard .bd-mix-legend {
  margin-top: 12px;
  font-size: 12px;
}
.business-dashboard .bd-mix-legend div {
  display: flex;
  justify-content: space-between;
  margin-top: 8px;
}
.business-dashboard .bd-table-wrap {
  overflow-x: auto;
  scrollbar-width: thin;
  scrollbar-color: #9aa8d6 #eef1f8;
}
.business-dashboard .bd-table-wrap::-webkit-scrollbar {
  height: 6px;
  width: 6px;
}
.business-dashboard .bd-table-wrap::-webkit-scrollbar-track {
  background: #eef1f8;
  border-radius: 99px;
}
.business-dashboard .bd-table-wrap::-webkit-scrollbar-thumb {
  background: #9aa8d6;
  border-radius: 99px;
}
.business-dashboard .bd-table-wrap::-webkit-scrollbar-thumb:hover {
  background: #2f5bea;
}
.business-dashboard .bd-table-wrap::-webkit-scrollbar-corner {
  background: transparent;
}
.business-dashboard .bd-table-scroll {
  max-height: 251px;
  overflow: auto;
  scrollbar-width: thin;
  scrollbar-color: #9aa8d6 #eef1f8;
}
.business-dashboard .bd-table-scroll::-webkit-scrollbar {
  height: 6px;
  width: 6px;
}
.business-dashboard .bd-table-scroll::-webkit-scrollbar-track {
  background: #eef1f8;
  border-radius: 99px;
}
.business-dashboard .bd-table-scroll::-webkit-scrollbar-thumb {
  background: #9aa8d6;
  border-radius: 99px;
}
.business-dashboard .bd-table-scroll::-webkit-scrollbar-thumb:hover {
  background: #2f5bea;
}
.business-dashboard .bd-table-scroll::-webkit-scrollbar-corner {
  background: transparent;
}
.business-dashboard .bd-table-scroll .bd-table th {
  position: sticky;
  top: 0;
  background: var(--bd-card);
  z-index: 1;
}
.business-dashboard .bd-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}
.business-dashboard .bd-table th {
  text-align: right;
  color: var(--bd-muted);
  font-weight: 600;
  padding: 12px 8px;
  border-bottom: 1px solid var(--bd-line);
  white-space: nowrap;
}
.business-dashboard .bd-table th:first-child,
.business-dashboard .bd-table td:first-child {
  text-align: left;
}
.business-dashboard .bd-table td {
  text-align: right;
  padding: 12px 8px;
  border-bottom: 1px solid var(--bd-line);
  white-space: nowrap;
}
.business-dashboard .bd-table tr:last-child td {
  border-bottom: none;
}
.business-dashboard .bd-footer {
  font-size: 10px;
  color: var(--bd-soft);
  margin-top: 8px;
}
.business-dashboard .bd-money[title] {
  cursor: help;
}
.business-dashboard .bd-money {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
}
.business-dashboard .bd-money .currency-symbol {
  margin: 0;
  font-size: 1em;
  line-height: 1;
}
@media (min-width: 640px) {
  .business-dashboard .bd-nested-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .business-dashboard .bd-nested-head {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
  .business-dashboard .bd-grid-4,
  .business-dashboard .bd-grid-5 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .business-dashboard .bd-workshop-kpis,
  .business-dashboard .bd-fleet-kpis {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .business-dashboard .bd-span-2 {
    grid-column: span 2;
  }
}
@media (min-width: 1024px) {
  .business-dashboard .bd-grid-2,
  .business-dashboard .bd-trend-grid {
    grid-template-columns: 1.6fr 1fr;
  }
  .business-dashboard .bd-grid-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .business-dashboard .bd-grid-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .business-dashboard .bd-grid-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
  .business-dashboard .bd-workshop-kpis,
  .business-dashboard .bd-fleet-kpis {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}
@media (min-width: 1280px) {
  .business-dashboard .bd-workshop-kpis {
    grid-template-columns: repeat(7, minmax(0, 1fr));
  }
  .business-dashboard .bd-fleet-kpis {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
  .business-dashboard .bd-span-2 {
    grid-column: span 2;
  }
  .business-dashboard .bd-trend-grid {
    grid-template-columns: 2fr 1fr;
  }
}

body.bd-print-mode {
  overflow: visible !important;
  height: auto !important;
  background: #fff !important;
}
body.bd-print-mode .fms-header,
body.bd-print-mode .fms-footer,
body.bd-print-mode .main-navigation,
body.bd-print-mode .MuiDrawer-root,
body.bd-print-mode .demo-notification-bar {
  display: none !important;
}
body.bd-print-mode .main-view,
body.bd-print-mode .main-view.no-sidebar,
body.bd-print-mode .main-view.side-menu-open,
body.bd-print-mode .has-padding {
  position: static !important;
  overflow: visible !important;
  height: auto !important;
  max-height: none !important;
  width: 100% !important;
  left: 0 !important;
  right: 0 !important;
  top: 0 !important;
  bottom: auto !important;
  margin: 0 !important;
  padding: 0 !important;
}
body.bd-print-mode .business-dashboard {
  margin: 0 !important;
  min-height: 0 !important;
  overflow: visible !important;
}
body.bd-print-mode .business-dashboard .bd-toolbar-actions,
body.bd-print-mode .business-dashboard .bd-print-btn {
  display: none !important;
}
body.bd-print-mode .business-dashboard .bd-section {
  page-break-inside: auto;
  break-inside: auto;
}
body.bd-print-mode .business-dashboard .bd-card {
  box-shadow: none !important;
  page-break-inside: avoid;
  break-inside: avoid;
}
body.bd-print-mode .business-dashboard .bd-kpi,
body.bd-print-mode .business-dashboard .bd-toolbar {
  page-break-inside: avoid;
  break-inside: avoid;
}
body.bd-print-mode .business-dashboard .highcharts-container,
body.bd-print-mode .business-dashboard .highcharts-container svg {
  overflow: visible !important;
}
body.bd-print-mode .business-dashboard .bd-table-wrap,
body.bd-print-mode .business-dashboard .bd-table-scroll {
  max-height: none !important;
  overflow: visible !important;
}

@media print {
  body.bd-print-mode {
    print-color-adjust: exact;
    -webkit-print-color-adjust: exact;
  }
  body.bd-print-mode,
  body.bd-print-mode #root {
    height: auto !important;
    overflow: visible !important;
    background: #fff !important;
  }
  body.bd-print-mode .business-dashboard {
    background: #fff !important;
    margin: 0 !important;
    padding: 0 !important;
    min-height: 0 !important;
    width: 100% !important;
    overflow: visible !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/Pages/BusinessDashboard/businessDashboard.scss","webpack://./src/Pages/shared/_dashboardScrollbar.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB,oEAAA;ADEA;EACE,oBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;EACA,qBAAA;EACA,oBAAA;EACA,qBAAA;EACA,gEAAA;EACA,iBAAA;EACA,gBAAA;EACA,4BAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,WAAA;AACF;AAEE;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;AAAJ;AAGE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;EACA,kBAAA;AADJ;AAIE;EACE,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,sBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;AAFJ;AAKE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,iBAAA;EACA,cAAA;AAHJ;AAME;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AAJJ;AAOE;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;AALJ;AAQE;;EAEE,gCAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,aAAA;EACA,gBAAA;AANJ;AASE;EACE,qBAAA;AAPJ;AAUE;EACE,mBAAA;EACA,WAAA;EACA,qBAAA;EACA,gBAAA;EACA,eAAA;AARJ;AAWE;EACE,mBAAA;AATJ;AAYE;EACE,mBAAA;AAVJ;AAaE;EACE,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EACA,SAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;AAXJ;AAcE;EACE,mBAAA;EACA,aAAA;EACA,eAAA;EACA,SAAA;EACA,iBAAA;AAZJ;AAeE;EACE,mBAAA;EACA,gBAAA;EACA,gCAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;EACA,QAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;UAAA,iBAAA;AAbJ;AAeI;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,SAAA;AAbN;AAiBE;EACE,mBAAA;EACA,oBAAA;EACA,oBAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,iCAAA;EACA,WAAA;AAfJ;AAkBE;EACE,gBAAA;EACA,kBAAA;EACA,2CAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;EACA,QAAA;EACA,gCAAA;EACA,WAAA;AAhBJ;AAmBE;EACE,8BAAA;AAjBJ;AAoBE;EACE,2BAAA;AAlBJ;AAqBE;EACE,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAnBJ;AAsBE;EACE,SAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,gBAAA;EACA,sBAAA;AApBJ;AAuBE;EACE,yBAAA;AArBJ;AAwBE;EACE,sBAAA;AAtBJ;AAyBE;EACE,uBAAA;AAvBJ;AA0BE;;EAEE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,iBAAA;EACA,cAAA;AAxBJ;AA2BE;;EAEE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AAzBJ;AA4BE;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,iBAAA;AA1BJ;AA6BE;EACE,yBAAA;AA3BJ;AA8BE;EACE,sBAAA;AA5BJ;AA+BE;EACE,uBAAA;AA7BJ;AAgCE;EACE,aAAA;EACA,cAAA;EAAA,SAAA;AA9BJ;AAiCE;EACE,gDAAA;AA/BJ;AAkCE;EACE,0BAAA;AAhCJ;AAmCE;EACE,0BAAA;AAjCJ;AAoCE;EACE,0BAAA;AAlCJ;AAqCE;EACE,0BAAA;AAnCJ;AAsCE;EACE,0BAAA;EACA,gCAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AApCJ;AAuCE;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;EACA,wBAAA;EACA,aAAA;EACA,oBAAA;AArCJ;AAwCE;EACE,yCAAA;EACA,yBAAA;AAtCJ;AAyCE;EACE,sCAAA;EACA,sBAAA;AAvCJ;AA0CE;EACE,uCAAA;EACA,uBAAA;AAxCJ;AA2CE;EACE,SAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,sBAAA;EACA,gBAAA;AAzCJ;AA4CE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;AA1CJ;AA6CE;EACE,YAAA;AA3CJ;AA8CE;EACE,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,cAAA;EACA,YAAA;EACA,qBAAA;AA5CJ;AA+CE;EACE,sBAAA;AA7CJ;AAgDE;EACE,0BAAA;AA9CJ;AAiDE;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,gBAAA;AA/CJ;AAkDE;EACE,yBAAA;AAhDJ;AAmDE;EACE,sBAAA;AAjDJ;AAoDE;EACE,uBAAA;AAlDJ;AAqDE;EACE,wBAAA;AAnDJ;AAsDE;EACE,aAAA;EACA,SAAA;EACA,eAAA;EACA,eAAA;AApDJ;AAuDE;EACE,yBAAA;AArDJ;AAwDE;EACE,uBAAA;AAtDJ;AAyDE;EACE,sBAAA;AAvDJ;AA0DE;EACE,wBAAA;AAxDJ;AA2DE;EACE,uBAAA;AAzDJ;AA4DE;EACE,iBAAA;AA1DJ;AA6DE;;EAEE,aAAA;EACA,0BAAA;EACA,cAAA;EAAA,SAAA;AA3DJ;AA8DE;EACE,YAAA;AA5DJ;AA+DE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AA7DJ;AAgEE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,2BAAA;EACA,gCAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;AA9DJ;AAiEE;EACE,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,sBAAA;AA/DJ;AAkEE;EACE,eAAA;AAhEJ;AAmEE;EACE,aAAA;EACA,0BAAA;EACA,cAAA;EAAA,SAAA;EACA,gBAAA;AAjEJ;AAoEE;EACE,2BAAA;EACA,kBAAA;EACA,aAAA;AAlEJ;AAqEE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AAnEJ;AAsEE;EACE,gBAAA;EACA,eAAA;EACA,qBAAA;AApEJ;AAuEE;EACE,eAAA;EACA,sBAAA;EACA,yCAAA;EACA,oCAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AArEJ;AAwEE;EACE,aAAA;EACA,qCAAA;EACA,aAAA;EAAA,QAAA;EACA,gBAAA;AAtEJ;AAyEE;EACE,2BAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;AAvEJ;AA0EE;EACE,SAAA;EACA,cAAA;EACA,yBAAA;EACA,qBAAA;AAxEJ;AA2EE;EACE,cAAA;EACA,eAAA;AAzEJ;AA4EE;EACE,2BAAA;EACA,gCAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;AA1EJ;AA6EE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AA3EJ;AA8EE;EACE,aAAA;EACA,gDAAA;EACA,aAAA;EAAA,QAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;AA5EJ;AA+EE;EACE,SAAA;EACA,cAAA;EACA,qBAAA;AA7EJ;AAgFE;EACE,qCAAA;AA9EJ;AAiFE;EACE,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,mCAAA;EACA,yCAAA;EACA,eAAA;EACA,cAAA;AA/EJ;AAkFE;EACE,oCAAA;EACA,sCAAA;AAhFJ;AAmFE;EACE,sBAAA;AAjFJ;AAoFE;EACE,yBAAA;AAlFJ;AAqFE;EACE,gBAAA;AAnFJ;AAsFE;EACE,aAAA;EACA,8BAAA;EACA,eAAA;EACA,kBAAA;AApFJ;AAuFE;EACE,YAAA;EACA,4BAAA;EACA,oBAAA;EACA,gBAAA;AArFJ;AAwFE;EACE,WAAA;AAtFJ;AAyFE;EACE,cAAA;EACA,YAAA;EACA,oBAAA;AAvFJ;AA0FE;EACE,8BAAA;AAxFJ;AA2FE;EACE,2BAAA;AAzFJ;AA4FE;EACE,4BAAA;AA1FJ;AA6FE;EACE,6BAAA;AA3FJ;AA8FE;EACE,mBAAA;AA5FJ;AA+FE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AA7FJ;AAgGE;EACE,gBAAA;EACA,eAAA;AA9FJ;AAiGE;EACE,aAAA;EACA,8BAAA;EACA,eAAA;AA/FJ;AAkGE;EACE,gBAAA;EC7nBF,qBAAA;EACA,gCAAA;AD8hBF;AC5hBE;EACE,WD0nBwB;ECznBxB,UDynBwB;AA3F5B;AC3hBE;EACE,mBAAA;EACA,mBAAA;AD6hBJ;AC1hBE;EACE,mBAAA;EACA,mBAAA;AD4hBJ;ACzhBE;EACE,mBAAA;AD2hBJ;ACxhBE;EACE,uBAAA;AD0hBJ;AAgFE;EACE,iBAAA;EACA,cAAA;ECnoBF,qBAAA;EACA,gCAAA;ADsjBF;ACpjBE;EACE,WDgoBwB;EC/nBxB,UD+nBwB;AAzE5B;ACnjBE;EACE,mBAAA;EACA,mBAAA;ADqjBJ;ACljBE;EACE,mBAAA;EACA,mBAAA;ADojBJ;ACjjBE;EACE,mBAAA;ADmjBJ;AChjBE;EACE,uBAAA;ADkjBJ;AA8DE;EACE,gBAAA;EACA,MAAA;EACA,0BAAA;EACA,UAAA;AA5DJ;AA+DE;EACE,WAAA;EACA,yBAAA;EACA,eAAA;AA7DJ;AAgEE;EACE,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uCAAA;EACA,mBAAA;AA9DJ;AAiEE;;EAEE,gBAAA;AA/DJ;AAkEE;EACE,iBAAA;EACA,iBAAA;EACA,uCAAA;EACA,mBAAA;AAhEJ;AAmEE;EACE,mBAAA;AAjEJ;AAoEE;EACE,eAAA;EACA,qBAAA;EACA,eAAA;AAlEJ;AAqEE;EACE,YAAA;AAnEJ;AAsEE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;AApEJ;AAuEE;EACE,SAAA;EACA,cAAA;EACA,cAAA;AArEJ;AAwEE;EACE;IACE,gDAAA;EAtEJ;EAyEE;IACE,mBAAA;IACA,mBAAA;IACA,8BAAA;EAvEJ;EA0EE;;IAEE,gDAAA;EAxEJ;EA2EE;;IAEE,gDAAA;EAzEJ;EA4EE;IACE,mBAAA;EA1EJ;AACF;AA6EE;EACE;;IAEE,gCAAA;EA3EJ;EA8EE;IACE,gDAAA;EA5EJ;EA+EE;IACE,gDAAA;EA7EJ;EAgFE;IACE,gDAAA;EA9EJ;EAiFE;;IAEE,gDAAA;EA/EJ;AACF;AAkFE;EACE;IACE,gDAAA;EAhFJ;EAkFE;IACE,gDAAA;EAhFJ;EAmFE;IACE,mBAAA;EAjFJ;EAoFE;IACE,8BAAA;EAlFJ;AACF;;AAsFA;EACE,4BAAA;EACA,uBAAA;EACA,2BAAA;AAnFF;AAqFE;;;;;EAKE,wBAAA;AAnFJ;AAsFE;;;;EAIE,2BAAA;EACA,4BAAA;EACA,uBAAA;EACA,2BAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,uBAAA;EACA,oBAAA;EACA,qBAAA;AApFJ;AAuFE;EACE,oBAAA;EACA,wBAAA;EACA,4BAAA;AArFJ;AAuFI;;EAEE,wBAAA;AArFN;AAwFI;EACE,uBAAA;EACA,kBAAA;AAtFN;AAyFI;EACE,2BAAA;EACA,wBAAA;EACA,mBAAA;AAvFN;AA0FI;;EAEE,wBAAA;EACA,mBAAA;AAxFN;AA2FI;;EAEE,4BAAA;AAzFN;AA4FI;;EAEE,2BAAA;EACA,4BAAA;AA1FN;;AA+FA;EACE;IACE,yBAAA;IACA,iCAAA;EA5FF;EA8FE;;IAEE,uBAAA;IACA,4BAAA;IACA,2BAAA;EA5FJ;EA+FE;IACE,2BAAA;IACA,oBAAA;IACA,qBAAA;IACA,wBAAA;IACA,sBAAA;IACA,4BAAA;EA7FJ;AACF","sourcesContent":["@import \"../shared/dashboardScrollbar\";\n\n.business-dashboard {\n  --bd-canvas: #f3f4f8;\n  --bd-card: #ffffff;\n  --bd-card2: #f7f8fb;\n  --bd-line: #e3e5ee;\n  --bd-text: #161a3a;\n  --bd-muted: #646a8a;\n  --bd-soft: #9aa0bb;\n  --bd-workshop: #00c179;\n  --bd-fleet: #3b82f6;\n  --bd-sianty: #8b5cf6;\n  --bd-warning: #f59e0b;\n  --bd-danger: #ef4444;\n  color: var(--bd-text);\n  font-family: \"Open Sans\", \"Roboto\", Helvetica, Arial, sans-serif;\n  font-size: 13.5px;\n  line-height: 1.4;\n  background: var(--bd-canvas);\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin: -20px;\n  padding: 12px 12px 24px;\n  min-height: calc(100vh - 64px);\n  width: auto;\n\n  // Page header — matches ExDashboard ContractTypeFilterBar\n  .bd-toolbar {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    margin-bottom: 0;\n    padding: 10px 14px;\n    background: #fff;\n    border: 1px solid #e3e5ee;\n    border-radius: 10px;\n    box-shadow: none;\n  }\n\n  .bd-toolbar-left {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    min-width: 0;\n    padding-right: 8px;\n  }\n\n  .bd-badge {\n    background: #00c179;\n    color: #fff;\n    font-weight: 700;\n    letter-spacing: 0.04em;\n    font-size: 12px;\n    padding: 8px 12px;\n    border-radius: 8px;\n    white-space: nowrap;\n  }\n\n  .bd-toolbar h1 {\n    margin: 0;\n    font-size: 16px;\n    font-weight: 700;\n    letter-spacing: -0.01em;\n    line-height: 1.25;\n    color: #1b1f4b;\n  }\n\n  .bd-toolbar p {\n    margin: 2px 0 0;\n    font-size: 12px;\n    font-weight: 500;\n    line-height: 1.35;\n    color: #646a8a;\n  }\n\n  .bd-toolbar-actions {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 8px;\n    margin-left: auto;\n  }\n\n  .bd-select,\n  .bd-print-btn {\n    border: 1px solid var(--bd-line);\n    border-radius: 8px;\n    padding: 8px 12px;\n    font-size: 12px;\n    background: #fff;\n    color: var(--bd-text);\n    outline: none;\n    min-height: 36px;\n  }\n\n  .bd-select:focus {\n    border-color: #00c179;\n  }\n\n  .bd-print-btn {\n    background: #00c179;\n    color: #fff;\n    border-color: #00c179;\n    font-weight: 600;\n    cursor: pointer;\n  }\n\n  .bd-print-btn:hover {\n    background: #00b06e;\n  }\n\n  .bd-section {\n    margin-bottom: 12px;\n  }\n\n  .bd-section-head {\n    align-items: center;\n    background: #fff;\n    border: 1px solid #e3e5ee;\n    border-radius: 10px;\n    box-shadow: none;\n    display: flex;\n    flex-wrap: wrap;\n    gap: 12px;\n    justify-content: space-between;\n    margin-bottom: 12px;\n    padding: 10px 14px;\n  }\n\n  .bd-section-head-right {\n    align-items: center;\n    display: flex;\n    flex-wrap: wrap;\n    gap: 10px;\n    margin-left: auto;\n  }\n\n  .bd-switch {\n    align-items: center;\n    background: #fff;\n    border: 1px solid var(--bd-line);\n    border-radius: 8px;\n    cursor: pointer;\n    display: inline-flex;\n    gap: 8px;\n    min-height: 36px;\n    padding: 6px 10px;\n    user-select: none;\n\n    input {\n      position: absolute;\n      opacity: 0;\n      width: 0;\n      height: 0;\n    }\n  }\n\n  .bd-switch-track {\n    background: #d1d5e4;\n    border-radius: 999px;\n    display: inline-flex;\n    flex-shrink: 0;\n    height: 18px;\n    position: relative;\n    transition: background 0.15s ease;\n    width: 32px;\n  }\n\n  .bd-switch-thumb {\n    background: #fff;\n    border-radius: 50%;\n    box-shadow: 0 1px 2px rgba(22, 26, 58, 0.2);\n    height: 14px;\n    left: 2px;\n    position: absolute;\n    top: 2px;\n    transition: transform 0.15s ease;\n    width: 14px;\n  }\n\n  .bd-switch.is-on .bd-switch-track {\n    background: var(--bd-workshop);\n  }\n\n  .bd-switch.is-on .bd-switch-thumb {\n    transform: translateX(14px);\n  }\n\n  .bd-switch-text {\n    color: var(--bd-text);\n    font-size: 12px;\n    font-weight: 600;\n    line-height: 1.15;\n  }\n\n  .bd-eyebrow {\n    margin: 0;\n    font-size: 11px;\n    text-transform: uppercase;\n    letter-spacing: 0.12em;\n    font-weight: 700;\n    color: var(--bd-muted);\n  }\n\n  .bd-eyebrow.workshop {\n    color: var(--bd-workshop);\n  }\n\n  .bd-eyebrow.fleet {\n    color: var(--bd-fleet);\n  }\n\n  .bd-eyebrow.sianty {\n    color: var(--bd-sianty);\n  }\n\n  .bd-section-head h2,\n  .bd-card h2 {\n    margin: 2px 0 0;\n    font-size: 16px;\n    font-weight: 700;\n    letter-spacing: -0.01em;\n    line-height: 1.25;\n    color: #1b1f4b;\n  }\n\n  .bd-section-head p,\n  .bd-card .bd-sub {\n    margin: 2px 0 0;\n    font-size: 12px;\n    font-weight: 500;\n    line-height: 1.35;\n    color: #646a8a;\n  }\n\n  .bd-aside {\n    font-size: 12px;\n    font-weight: 500;\n    color: var(--bd-muted);\n    white-space: nowrap;\n    margin-left: auto;\n  }\n\n  .bd-aside.workshop {\n    color: var(--bd-workshop);\n  }\n\n  .bd-aside.fleet {\n    color: var(--bd-fleet);\n  }\n\n  .bd-aside.sianty {\n    color: var(--bd-sianty);\n  }\n\n  .bd-grid {\n    display: grid;\n    gap: 12px;\n  }\n\n  .bd-grid-4 {\n    grid-template-columns: repeat(1, minmax(0, 1fr));\n  }\n\n  .bd-grid-2 {\n    grid-template-columns: 1fr;\n  }\n\n  .bd-grid-3 {\n    grid-template-columns: 1fr;\n  }\n\n  .bd-grid-5 {\n    grid-template-columns: 1fr;\n  }\n\n  .bd-trend-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .bd-card {\n    background: var(--bd-card);\n    border: 1px solid var(--bd-line);\n    border-radius: 10px;\n    padding: 12px 14px;\n    box-shadow: none;\n    position: relative;\n    overflow: hidden;\n  }\n\n  .bd-card.accent::after {\n    content: \"\";\n    position: absolute;\n    right: -35px;\n    bottom: -55px;\n    width: 130px;\n    height: 130px;\n    border-radius: 9999px;\n    background: currentColor;\n    opacity: 0.05;\n    pointer-events: none;\n  }\n\n  .bd-card.workshop-border {\n    border-left: 4px solid var(--bd-workshop);\n    color: var(--bd-workshop);\n  }\n\n  .bd-card.fleet-border {\n    border-left: 4px solid var(--bd-fleet);\n    color: var(--bd-fleet);\n  }\n\n  .bd-card.sianty-border {\n    border-left: 4px solid var(--bd-sianty);\n    color: var(--bd-sianty);\n  }\n\n  .bd-label {\n    margin: 0;\n    font-size: 10px;\n    text-transform: uppercase;\n    letter-spacing: 0.08em;\n    color: var(--bd-muted);\n    font-weight: 600;\n  }\n\n  .bd-label-row {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    min-width: 0;\n  }\n\n  .bd-label-row .bd-label {\n    min-width: 0;\n  }\n\n  .bd-info {\n    display: inline-flex;\n    align-items: center;\n    line-height: 0;\n    flex: 0 0 auto;\n    cursor: help;\n    color: var(--bd-soft);\n  }\n\n  .bd-info:hover {\n    color: var(--bd-fleet);\n  }\n\n  .bd-info-icon {\n    font-size: 14px !important;\n  }\n\n  .bd-value {\n    margin: 8px 0 0;\n    font-size: 24px;\n    font-weight: 700;\n    color: var(--bd-text);\n    line-height: 1.2;\n  }\n\n  .bd-value.workshop {\n    color: var(--bd-workshop);\n  }\n\n  .bd-value.fleet {\n    color: var(--bd-fleet);\n  }\n\n  .bd-value.sianty {\n    color: var(--bd-sianty);\n  }\n\n  .bd-value.warning {\n    color: var(--bd-warning);\n  }\n\n  .bd-meta {\n    display: flex;\n    gap: 12px;\n    margin-top: 6px;\n    font-size: 12px;\n  }\n\n  .bd-up {\n    color: var(--bd-workshop);\n  }\n\n  .bd-down {\n    color: var(--bd-danger);\n  }\n\n  .bd-muted {\n    color: var(--bd-muted);\n  }\n\n  .bd-warning {\n    color: var(--bd-warning);\n  }\n\n  .bd-danger {\n    color: var(--bd-danger);\n  }\n\n  .bd-kpi {\n    min-height: 146px;\n  }\n\n  .bd-workshop-kpis,\n  .bd-fleet-kpis {\n    display: grid;\n    grid-template-columns: 1fr;\n    gap: 12px;\n  }\n\n  .bd-span-2 {\n    min-width: 0;\n  }\n\n  .bd-nested-head {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  .bd-pill {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    background: var(--bd-card2);\n    border: 1px solid var(--bd-line);\n    border-radius: 8px;\n    padding: 8px 12px;\n    width: fit-content;\n  }\n\n  .bd-pill > span {\n    font-size: 10px;\n    text-transform: uppercase;\n    letter-spacing: 0.08em;\n    color: var(--bd-muted);\n  }\n\n  .bd-pill b {\n    font-size: 18px;\n  }\n\n  .bd-nested-grid {\n    display: grid;\n    grid-template-columns: 1fr;\n    gap: 12px;\n    margin-top: 16px;\n  }\n\n  .bd-nested {\n    background: var(--bd-card2);\n    border-radius: 8px;\n    padding: 14px;\n  }\n\n  .bd-nested-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n\n  .bd-note {\n    margin-top: 10px;\n    font-size: 10px;\n    color: var(--bd-soft);\n  }\n\n  .bd-chip {\n    font-size: 10px;\n    color: var(--bd-fleet);\n    border: 1px solid rgba(59, 130, 246, 0.3);\n    background: rgba(59, 130, 246, 0.08);\n    padding: 4px 8px;\n    border-radius: 6px;\n    white-space: nowrap;\n  }\n\n  .bd-month-row {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 8px;\n    margin-top: 16px;\n  }\n\n  .bd-month {\n    background: var(--bd-card2);\n    border-radius: 8px;\n    padding: 8px;\n    text-align: center;\n  }\n\n  .bd-month p {\n    margin: 0;\n    font-size: 9px;\n    text-transform: uppercase;\n    color: var(--bd-soft);\n  }\n\n  .bd-month b {\n    display: block;\n    margin-top: 4px;\n  }\n\n  .bd-part {\n    background: var(--bd-card2);\n    border: 1px solid var(--bd-line);\n    border-radius: 8px;\n    padding: 12px;\n    margin-top: 12px;\n  }\n\n  .bd-part-head {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 8px;\n    font-size: 12px;\n  }\n\n  .bd-part-grid {\n    display: grid;\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n    gap: 8px;\n    margin-top: 12px;\n    text-align: center;\n    font-size: 12px;\n  }\n\n  .bd-part-grid p {\n    margin: 0;\n    font-size: 9px;\n    color: var(--bd-soft);\n  }\n\n  .bd-part-total {\n    border-left: 1px solid var(--bd-line);\n  }\n\n  .bd-insight {\n    margin-top: 12px;\n    padding: 12px;\n    border-radius: 8px;\n    background: rgba(0, 193, 121, 0.08);\n    border: 1px solid rgba(0, 193, 121, 0.18);\n    font-size: 11px;\n    color: #334155;\n  }\n\n  .bd-insight.fleet {\n    background: rgba(59, 130, 246, 0.08);\n    border-color: rgba(59, 130, 246, 0.18);\n  }\n\n  .bd-insight b.fleet {\n    color: var(--bd-fleet);\n  }\n\n  .bd-insight b.workshop {\n    color: var(--bd-workshop);\n  }\n\n  .bd-progress {\n    margin-top: 20px;\n  }\n\n  .bd-progress-row {\n    display: flex;\n    justify-content: space-between;\n    font-size: 12px;\n    margin-bottom: 6px;\n  }\n\n  .bd-bar {\n    height: 10px;\n    background: var(--bd-canvas);\n    border-radius: 999px;\n    overflow: hidden;\n  }\n\n  .bd-bar.thin {\n    height: 8px;\n  }\n\n  .bd-bar > span {\n    display: block;\n    height: 100%;\n    border-radius: 999px;\n  }\n\n  .bd-bar.workshop > span {\n    background: var(--bd-workshop);\n  }\n\n  .bd-bar.fleet > span {\n    background: var(--bd-fleet);\n  }\n\n  .bd-bar.sianty > span {\n    background: var(--bd-sianty);\n  }\n\n  .bd-bar.warning > span {\n    background: var(--bd-warning);\n  }\n\n  .bd-bar.slate > span {\n    background: #94a3b8;\n  }\n\n  .bd-stat-row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n  }\n\n  .bd-mix-legend {\n    margin-top: 12px;\n    font-size: 12px;\n  }\n\n  .bd-mix-legend div {\n    display: flex;\n    justify-content: space-between;\n    margin-top: 8px;\n  }\n\n  .bd-table-wrap {\n    overflow-x: auto;\n    @include dash-scrollbar(6px);\n  }\n\n  .bd-table-scroll {\n    max-height: 251px;\n    overflow: auto;\n    @include dash-scrollbar(6px);\n  }\n\n  .bd-table-scroll .bd-table th {\n    position: sticky;\n    top: 0;\n    background: var(--bd-card);\n    z-index: 1;\n  }\n\n  .bd-table {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: 12px;\n  }\n\n  .bd-table th {\n    text-align: right;\n    color: var(--bd-muted);\n    font-weight: 600;\n    padding: 12px 8px;\n    border-bottom: 1px solid var(--bd-line);\n    white-space: nowrap;\n  }\n\n  .bd-table th:first-child,\n  .bd-table td:first-child {\n    text-align: left;\n  }\n\n  .bd-table td {\n    text-align: right;\n    padding: 12px 8px;\n    border-bottom: 1px solid var(--bd-line);\n    white-space: nowrap;\n  }\n\n  .bd-table tr:last-child td {\n    border-bottom: none;\n  }\n\n  .bd-footer {\n    font-size: 10px;\n    color: var(--bd-soft);\n    margin-top: 8px;\n  }\n\n  .bd-money[title] {\n    cursor: help;\n  }\n\n  .bd-money {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    white-space: nowrap;\n  }\n\n  .bd-money .currency-symbol {\n    margin: 0;\n    font-size: 1em;\n    line-height: 1;\n  }\n\n  @media (min-width: 640px) {\n    .bd-nested-grid {\n      grid-template-columns: repeat(2, minmax(0, 1fr));\n    }\n\n    .bd-nested-head {\n      flex-direction: row;\n      align-items: center;\n      justify-content: space-between;\n    }\n\n    .bd-grid-4,\n    .bd-grid-5 {\n      grid-template-columns: repeat(2, minmax(0, 1fr));\n    }\n\n    .bd-workshop-kpis,\n    .bd-fleet-kpis {\n      grid-template-columns: repeat(2, minmax(0, 1fr));\n    }\n\n    .bd-span-2 {\n      grid-column: span 2;\n    }\n  }\n\n  @media (min-width: 1024px) {\n    .bd-grid-2,\n    .bd-trend-grid {\n      grid-template-columns: 1.6fr 1fr;\n    }\n\n    .bd-grid-3 {\n      grid-template-columns: repeat(3, minmax(0, 1fr));\n    }\n\n    .bd-grid-4 {\n      grid-template-columns: repeat(4, minmax(0, 1fr));\n    }\n\n    .bd-grid-5 {\n      grid-template-columns: repeat(5, minmax(0, 1fr));\n    }\n\n    .bd-workshop-kpis,\n    .bd-fleet-kpis {\n      grid-template-columns: repeat(4, minmax(0, 1fr));\n    }\n  }\n\n  @media (min-width: 1280px) {\n    .bd-workshop-kpis{\n      grid-template-columns: repeat(7, minmax(0, 1fr));\n    }\n    .bd-fleet-kpis {\n      grid-template-columns: repeat(6, minmax(0, 1fr));\n    }\n\n    .bd-span-2 {\n      grid-column: span 2;\n    }\n\n    .bd-trend-grid {\n      grid-template-columns: 2fr 1fr;\n    }\n  }\n}\n\nbody.bd-print-mode {\n  overflow: visible !important;\n  height: auto !important;\n  background: #fff !important;\n\n  .fms-header,\n  .fms-footer,\n  .main-navigation,\n  .MuiDrawer-root,\n  .demo-notification-bar {\n    display: none !important;\n  }\n\n  .main-view,\n  .main-view.no-sidebar,\n  .main-view.side-menu-open,\n  .has-padding {\n    position: static !important;\n    overflow: visible !important;\n    height: auto !important;\n    max-height: none !important;\n    width: 100% !important;\n    left: 0 !important;\n    right: 0 !important;\n    top: 0 !important;\n    bottom: auto !important;\n    margin: 0 !important;\n    padding: 0 !important;\n  }\n\n  .business-dashboard {\n    margin: 0 !important;\n    min-height: 0 !important;\n    overflow: visible !important;\n\n    .bd-toolbar-actions,\n    .bd-print-btn {\n      display: none !important;\n    }\n\n    .bd-section {\n      page-break-inside: auto;\n      break-inside: auto;\n    }\n\n    .bd-card {\n      box-shadow: none !important;\n      page-break-inside: avoid;\n      break-inside: avoid;\n    }\n\n    .bd-kpi,\n    .bd-toolbar {\n      page-break-inside: avoid;\n      break-inside: avoid;\n    }\n\n    .highcharts-container,\n    .highcharts-container svg {\n      overflow: visible !important;\n    }\n\n    .bd-table-wrap,\n    .bd-table-scroll {\n      max-height: none !important;\n      overflow: visible !important;\n    }\n  }\n}\n\n@media print {\n  body.bd-print-mode {\n    print-color-adjust: exact;\n    -webkit-print-color-adjust: exact;\n\n    &,\n    #root {\n      height: auto !important;\n      overflow: visible !important;\n      background: #fff !important;\n    }\n\n    .business-dashboard {\n      background: #fff !important;\n      margin: 0 !important;\n      padding: 0 !important;\n      min-height: 0 !important;\n      width: 100% !important;\n      overflow: visible !important;\n    }\n  }\n}\n","/* Shared enterprise scrollbar — import into dashboard SCSS roots. */\n\n@mixin dash-scrollbar($size: 6px) {\n  scrollbar-width: thin;\n  scrollbar-color: #9aa8d6 #eef1f8;\n\n  &::-webkit-scrollbar {\n    height: $size;\n    width: $size;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: #eef1f8;\n    border-radius: 99px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: #9aa8d6;\n    border-radius: 99px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #2f5bea;\n  }\n\n  &::-webkit-scrollbar-corner {\n    background: transparent;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
